export const STATUS_RENCANA_AKSI = {
  DRAFT: 'Draf',
  PEMENUHAN_KELENGKAPAN_DOKUMEN: 'Pemenuhan Kelengkapan Dokumen Persiapan',
  MENUNGGU_DATA_PEMRAKARSA: 'Menunggu Data Pemrakarsa',
  SIAP_DINILAI: 'Siap Dinilai',
  DALAM_PENILAIAN: 'Dalam Penilaian',
  SELESAI: 'Selesai',
}
